<div class="asiakas-import-container">
  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div class="debug-laatikko">
      <h3>Urit</h3>
      <div>
        Asiakas-import-doc: <a [href]="asiakasImportDocLinkkiObservable | async" target="_BLANK">{{ asiakasImportDocUriObservable | async }}</a>
      </div>
      <div>
        Asiakkaat-kollektio (lemonaid): <a [href]="asiakkaatCollectionLinkkiObservable | async" target="_BLANK">{{ asiakkaatCollectionUriObservable | async }}</a>
      </div>
    </div>
  }

  <mat-tab-group [(selectedIndex)]="aktiivinenTabiIndex" dynamicHeight>
    <mat-tab label="Tuonti">
      <div class="tab-sisalto">
        @if (vaihe === 'idle') {
          <div class="ohje-laatikko">
            <p>Ei valittua tuontitiedostoa. Lataa Netvisorin asiakasrekisteri-XLSX tai Procountorin liikekumppaniraportti-XLS hallintokansioon ja valitse se tuontilähteeksi sieltä.</p>
            <app-primary-button (click)="siirryHallintokansioon()" actionId="Siirry hallintokansioon asiakas-importia varten"> Siirry hallintokansioon </app-primary-button>
          </div>
        }

        @if (vaihe === 'processing') {
          <div class="processing">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Käsitellään tiedostoa…</p>
          </div>
        }

        @if (vaihe === 'preview' || vaihe === 'done') {
          @if (tiedostonTiedotObservable | async; as tiedot) {
            <p class="tiedosto-rivi">
              Tiedosto: <strong>{{ tiedot.tiedostonNimi || tiedot.arkistoTiedostonAvain }}</strong>
              @if (tiedot.lahdejarjestelma) {
                <span class="lahde-badge">{{ tiedot.lahdejarjestelma }}</span>
              }
            </p>
          }

          @if (vaihe === 'done' && tallennusTulos) {
            <div class="onnistuminen">
              Tallennettiin <strong>{{ tallennusTulos.tallennetut }}</strong> asiakasta
              @if (tallennusTulos.ohitetutDuplikaatit > 0) {
                , ohitettiin <strong>{{ tallennusTulos.ohitetutDuplikaatit }}</strong> duplikaattia
              }
              .
            </div>
          }

          @if (rivitObservable | async; as rivit) {
            <div class="taulukko-ylaosa">
              @if (vaihe === 'preview') {
                <p>
                  Esikatselu: <strong>{{ rivit.length }}</strong> riviä. Duplikaatit (sama ulkoinen tunniste) suodatetaan automaattisesti tallennusvaiheessa.
                </p>
              }
            </div>
            <div class="taulukko-wrap">
              <table class="asiakas-taulukko">
                <thead>
                  <tr>
                    <th>Ulk. tunniste</th>
                    <th>Nimi</th>
                    <th>Y-tunnus</th>
                    <th>Tyyppi</th>
                    <th>Osoite</th>
                    <th>Postinro</th>
                    <th>Toimipaikka</th>
                    <th>Maa</th>
                    <th>Verkkolasku</th>
                    <th>Operaattori</th>
                    <th>Sähköposti</th>
                    <th>Kieli</th>
                  </tr>
                </thead>
                <tbody>
                  @for (rivi of rivit; track rivi.rivinumero) {
                    <tr [class.poistettu-rivi]="rivi.poistettu">
                      <td class="mono">{{ rivi.ulkoinenTunniste }}</td>
                      <td>{{ rivi.nimi }}</td>
                      <td class="mono">{{ rivi.ytunnus }}</td>
                      <td>{{ rivi.asiakastyyppi === 'h' ? 'Henkilö' : 'Yritys' }}</td>
                      <td>{{ rivi.katuosoite }}</td>
                      <td class="mono">{{ rivi.postinro }}</td>
                      <td>{{ rivi.postitmp }}</td>
                      <td>{{ rivi.maa }}</td>
                      <td class="mono">{{ rivi.sahkoinenOsoite }}</td>
                      <td class="mono">{{ rivi.sahkoinenValittaja }}</td>
                      <td>{{ rivi.sahkoinenSposti }}</td>
                      <td>{{ rivi.laskunKieli }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <div class="toiminnot">
              @if (vaihe === 'preview') {
                <app-secondary-button (click)="peruuta()" actionId="Peruuta asiakas-tuonti">Peruuta</app-secondary-button>
                <div style="flex: 1"></div>
                <app-primary-button (click)="tallenna()" actionId="Tallenna asiakas-tuonti"> Tallenna {{ rivit.length }} asiakasta </app-primary-button>
              }
              @if (vaihe === 'done') {
                <div style="flex: 1"></div>
                <app-primary-button (click)="peruuta()" actionId="Aloita uusi asiakas-tuonti">Tee uusi tuonti</app-primary-button>
              }
            </div>
          }
        }

        @if (vaihe === 'error' && virhe) {
          <div class="virhe-viesti">{{ virhe }}</div>
          <div class="toiminnot">
            <app-secondary-button (click)="peruuta()" actionId="Palaa asiakas-tuonnin alkuun">Takaisin</app-secondary-button>
            @if (naytaLahdejarjestelmanValinta) {
              <div style="flex: 1"></div>
              <app-primary-button (click)="valitseLahdejarjestelmaJaParsi()" actionId="Valitse asiakas-tuonnin lähdejärjestelmä">Valitse lähdejärjestelmä</app-primary-button>
            }
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Historia">
      <div class="tab-sisalto">
        @if (historiaObservable | async; as historia) {
          <table class="historia-taulukko">
            <thead>
              <tr>
                <th>Aika</th>
                <th>Lähdejärjestelmä</th>
                <th>Tiedosto</th>
                <th>Lataaja</th>
                <th class="num">Tallennetut</th>
                <th class="num">Duplikaatit</th>
              </tr>
            </thead>
            <tbody>
              @for (entry of historia; track entry.avain) {
                <tr>
                  <td>{{ entry.tuotu?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</td>
                  <td>{{ entry.lahdejarjestelma }}</td>
                  <td>{{ entry.tiedostonNimi || '–' }}</td>
                  <td>{{ annaKayttajanNimi(entry.tuoja, kayttajienNimetMapObservable | async) }}</td>
                  <td class="num">{{ entry.tallennetutAsiakkaat }}</td>
                  <td class="num">{{ entry.ohitetutDuplikaatit || 0 }}</td>
                </tr>
              }
              @if (historia.length === 0) {
                <tr>
                  <td colspan="6" class="tyhja-rivi">Ei aiempia tuonteja.</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
